import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class ParagraphText extends Component {
  render() {
    const sectionClassNames = classNames({
      'paragraph paragraph-text': true,
      'background-color': this.props.content.fieldFarbigHinterlegen
    });

    return (
      <section className={sectionClassNames}>

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text" dangerouslySetInnerHTML={{ __html: this.props.content.fieldText.value }} />
            </div>
          </div>
        </div>

      </section>
    );
  }
}

ParagraphText.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphText;
